import { render } from "./1.AboutParallax.vue?vue&type=template&id=173da1e3&scoped=true"
import script from "./1.AboutParallax.vue?vue&type=script&lang=js"
export * from "./1.AboutParallax.vue?vue&type=script&lang=js"

import "./1.AboutParallax.vue?vue&type=style&index=0&id=173da1e3&scoped=true&lang=css"
import "./1.AboutParallax.vue?vue&type=style&index=1&id=173da1e3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173da1e3"]])

export default __exports__